function CaseStudiesController(){
	this.className			= "CaseStudiesController";
	this.glob				= [
		"/case-studies/**",
		"/service/*/case-study/**",
		"/property-sourcing/case-study/**",
		"/property-search/case-study/**",
		"/property-management/case-study/**",
		"/property-management/rental-management/case-study/**",
		"/property-management/home-management/case-study/**"
	];
	this.globMain			= true;
}

CaseStudiesController.inheritsFrom( StandardController );
// CaseStudiesController.inheritsFrom( PageController );

CaseStudiesController.prototype.setup = function(){

	if(this.isSetup) return;

	this.$body				= $("body");

	// when the page first loads, it'll either be a main listing page or a case study page.
	// We'll create the other page ready
	const navDetails 	= this.navDetails();
	this.type 			= navDetails.type;

	const $jsBody		= this.$body.find('.js-body');
	const jsBody		= $jsBody[0];

	// create the other wrapper, whichever is required
	const div = document.createElement("div");
	div.classList.add("page-body");

	let cs, main;

	// create the case study wrapper
	if(this.type !== "caseStudy"){
		// insert the case study wrapper
		cs 						= div;
		main 					= jsBody;
		main.after(cs);

		cs.classList.add("case-study-hidden");
		this.mainHasContent 	= true; // so we know that we need to load it later
	} else {
		// insert the main wrapper
		cs 						= jsBody;
		main 					= div;
		cs.before(main);
	}

	this.mainWrapper 		= main;
	this.caseStudyWrapper 	= cs;


	main.classList.add("js-body-main")
	main.classList.add("main-wrapper");
	cs.classList.add("js-body-cs")
	cs.classList.add("case-study-wrapper");


	this.caches = {}
	jcache.addListener("loaded", (e) => {
		const meta 	= e.meta;
		const image = meta?.image;
		console.log(image, ' image');

		const href = e.url;
		if(href){
			const cache = this.caches[href];
			if(cache){
				cache.status 	= "ready";
				cache.image 	= image;
				Preloader2.add({src:image});
			}
		}

	});

	this.setupPreloads(main);
	// this.setupCaseStudyPreloads();

	// Case study page setup for returning from Property Sourcing via View all
	console.log('this should run');
	this.setupCaseStudyListPage();

	this.isSetup = true;

}

CaseStudiesController.prototype.swap = function() {
	console.log('setup running ssww');
	this.setup();
	if(this.type === "main") this.setupCaseStudyListPage();
	else this.setupCaseStudySinglePage();

	// Set up classes for landing intro
	if(this.$chosenFilter === '207') {
		this.$landingContent.removeClass('property-search--active');
		this.$landingContent.addClass('property-management--active');
	} else {
		this.$landingContent.removeClass('property-management--active');
		this.$landingContent.addClass('property-search--active');
	}
}

CaseStudiesController.prototype.onMain = function(onComplete){
	// are we changing section? If so we need to tell baseController to take over.
	if(this.navDetails().sectionChange) return Aviator.get("baseController").onMain(onComplete);
}

CaseStudiesController.prototype.off = function(onComplete) {

	// remove classes for landing intro
	this.$landingContent.removeClass('property-management--active');
	this.$landingContent.removeClass('property-search--active');

	this.unsetup();
}

CaseStudiesController.prototype.offMain = function(onComplete){
	// are we changing section? If so we need to tell baseController to take over.
	if(this.navDetails().sectionChange){
		// unsetup

		this.mainHasContent = false;

		return Aviator.get("baseController").offMain(() => {
			this.unsetup();
			onComplete();
		});
	}
}

CaseStudiesController.prototype.unsetup = function(onComplete){
	$(this.caseStudyWrapper).remove();
	this.unfixDiv(this.mainWrapper);
	$(this.mainWrapper).addClass("js-body").removeClass("main-wrapper").removeClass("js-body-main").removeClass("backgrounded");
	this.lastFilterItemId = false;
	this.isSetup = false;
}

CaseStudiesController.prototype.swapMain = function(onComplete){

	// are we changing section? If so we need to tell baseController to take over.
	if(this.navDetails().sectionChange){
		const r = Aviator.get("baseController").swapMain(onComplete);
		this.setup();
		return r;
	}

	const navDetails 		= this.navDetails();
	const type		 		= navDetails.type;
	const scrollTop 		= window.scrollY;

	const cs				= this.caseStudyWrapper;
	const main				= this.mainWrapper;

	const $cs 				= $(cs);
	const $main 			= $(main);

	if(type === "caseStudy"){
		const fromMain = navDetails.previousType === "main";

		// save the scroll position of the main page
		if(fromMain) this.previousScrollTop = scrollTop;
		console.log(this.previousScrollTop, ' this.previousScrollTop');

		// Load in the case study content
		this.loadHtml($cs, true);
		this.setupCaseStudySinglePage($cs);
		console.log('setup single cs page');

		// scroll case study to top
		$(window).scrollTop(0);

		// only show the popup when the image is ready
		// jquery because that's what inline trigger wants!

		if(fromMain){
			const $img = $cs.find("img")
			Preloader2.addInlineTrigger($img,(e) => {

				// freeze the current main page
				this.fixDiv(main);

				cs.classList.add("js-body");
				main.classList.remove("js-body");

				document.documentElement.scrollTop = 0; // check can i use

				//$cs.show().animate({opacity: 1}, {duration: 750}); //todo with css transitions
				cs.classList.remove("case-study-hidden");

				this.unfixDiv(cs);

			},0);
		}

	}else{

		// freeze and hide the case study
		if(!this.mainHasContent){
			this.loadHtml($main, false);
			this.setupPreloads(main);
			this.mainHasContent = true;
		}

		this.fixDiv(cs);

		cs.classList.remove("js-body");
		main.classList.add("js-body");

		// bring back right away - triggers the logo to reappear appropriately
		const scrollTop = this.previousScrollTop || (this.getMeta().is_case_study ? 0 : document.body.querySelector(".js-case-studies-block").getBoundingClientRect().top);
		this.unfixDiv(main);
		document.documentElement.scrollTop = scrollTop;
		console.log(this.previousScrollTop, ' this.previousScrollTop no cs');

		cs.classList.add("case-study-hidden");

		this.setupCaseStudyListPage();

	}
}

CaseStudiesController.prototype.setupCaseStudyListPage = function() {
	this.caseStudyLayout($(`.cs-property`));

	this.setupCaseStudyFilter();
}
CaseStudiesController.prototype.setupCaseStudySinglePage = function( $cs ) {
	this.setupCaseStudyPreloads();
	console.log('setup single cs page');
	($cs||$(`.js-body`)).find(".js-next-back").on("click", (e) => {
		$(e.currentTarget).find("a").trigger("click");
	})

}

CaseStudiesController.prototype.setupCaseStudyFilter = function() {

	this.filter 		 		= $('.filter a');
	this.$filterProperty 		= $('.filter-property');
	this.$filterPropertySearch = $('.parentID-206');
	this.$caseStudies	= $(".js-case-study");
	this.$landingContent	= $("body").find('.js-cs-landing-filter');

	this.$filterPropertySearch.addClass('filter-property--active');

	// Set correct landing intro to show
	this.$landingContent.removeClass('property-management--active');
	this.$landingContent.addClass('property-search--active');

	// Set filter to start with Search acquisition
	const activeFilter = $('.filter').find('.filter-property--active');
	const service = activeFilter.attr('data-service');
	const itemID = activeFilter.attr('data-itemid');

	$(".cs-property").hide();
	// this.caseStudyHrefTypeAddition(this.$caseStudies, itemID, service);
	// this.caseStudyLayout($(`.cs-property.parentID-${itemID}`));

	//SETUP UNTIL FULL FILTER FULLY TURNED ON
	this.caseStudyHrefTypeAddition(this.$caseStudies, itemID, service);

	// OLD only shows search - acquisition
	 this.caseStudyLayout($(`.cs-property.parentID-${itemID}`));

	// NEW now shows both
	//this.caseStudyLayout($('.cs-property'));
	// Set filter to start with Search acquisition ends

	const requestedFilter = nav.getState().nextParams.filter;
	if(!this.lastFilterItemId && requestedFilter){
		this.lastFilterItemId = $(`[data-service="${requestedFilter}"]`).attr("data-itemid");
	}

	this.$filterProperty.off("click").on('click', (e) => {
		console.log("am i clicked")
		this.filter.removeClass('filter-property--active');
		const itemID = e.currentTarget.dataset.itemid;
		this.$chosenFilter = itemID;
		$(".cs-property").hide();
		// console.log(itemID,  ' itemID???');

		if(e.currentTarget.dataset.itemid === '207') {
			this.$landingContent.removeClass('property-search--active');
			this.$landingContent.addClass('property-management--active');
		} else {
			this.$landingContent.removeClass('property-management--active');
			this.$landingContent.addClass('property-search--active');
		}
		console.log(e.currentTarget.dataset);

		this.lastFilterItemId = itemID;

		if(e.currentTarget.dataset.itemid === '0') {
			e.currentTarget.classList.add('filter-property--active');
			this.caseStudyLayout($(".cs-property"));

			console.log(itemID, ' itemID');

			//SETUP UNTIL FULL FILTER FULLY TURNED ON
			this.caseStudyHrefTypeAddition(this.$caseStudies, itemID);

		} else {
			this.filter.removeClass('filter-property--active');
			e.currentTarget.classList.add('filter-property--active');
			const service = e.currentTarget.getAttribute('data-service');

			//SETUP UNTIL FULL FILTER FULLY TURNED ON
			this.caseStudyHrefTypeAddition(this.$caseStudies, itemID, service);
			this.caseStudyLayout($(`.cs-property.parentID-${itemID}`));
		}

		Aviator.get("baseController").getImageController().resize();
	});

	if(this.lastFilterItemId ){
		this.$filterProperty.filter(`[data-itemid="${this.lastFilterItemId}"]`).trigger("click");
	}
}

CaseStudiesController.prototype.caseStudyLayout = function($caseStudies) {
	console.log('layout running');
	$(".cs-property").removeClass('case-study--middle').removeClass('case-study--even').removeClass('case-study--not-middle');
	$caseStudies.show();

	$caseStudies.each(function (i) {
		const mod = i % 3;
		const middle = mod === 1;
		const even = i % 2 === 1;

		if (middle) {
			$(this).addClass('case-study--middle');

		} else {
			$(this).addClass('case-study--not-middle');
		}

		if (even) {
			$(this).addClass('case-study--even');
		}

		$('.case-study__image-layout').removeClass('case-study--middle__image');
		$('.case-study--middle').find('.case-study__image-layout').addClass('case-study--middle__image');
	});
}

CaseStudiesController.prototype.caseStudyHrefTypeAddition = function($array, itemID, service) {

	const state = nav.getState();
	if(state.nextParts[0] === 'case-studies') {
		if (itemID === '0') {
			console.log(itemID, ' itemID if');
			// const originalHref = this.filter.find('.case-study__link').attr('href').split("?")[0];
			$array.each((i, item) => {
				const originalHref = $(item).find('.case-study__link').attr('href').split("?")[0];
				// console.log(originalHref, ' originalHref');
				$(item).find('.case-study__link').attr('href', originalHref);
			});
		} else {
			console.log(itemID, ' itemID else');
			$array.each((i, item) => {
				const originalHref = $(item).find('.case-study__link').attr('href').split("?")[0];
				$(item).find('.case-study__link').attr("href", originalHref);

				if (itemID === $(item).attr("data-parentid")) {
					const href = $(item).find('.case-study__link').attr('href').split("?")[0];
					$(item).find('.case-study__link').attr("href", `${href}?type=${service}`);
				}
			});
		}
	}
};

CaseStudiesController.prototype.setupPreloads = function(wrapper) {
	// preload the case study pages on rollover
	const links = [...wrapper.querySelectorAll(".js-case-study a")];
	links.forEach(link => {
		const href = link.getAttribute("href");
		link.addEventListener("mouseover", () => {
			console.log('setupPreloads');
			if(href) this.preloadImgHrefs(href);
		});
	});
};

CaseStudiesController.prototype.setupCaseStudyPreloads = function() {
	// preloads case studies for next and prev on individual case study page
	const linksNextPrev = [...document.querySelectorAll(".js-next-back a")];
	linksNextPrev.forEach(linkNP => {
		const href = linkNP.getAttribute("href");
		if(href) this.preloadImgHrefs(href);
	});
};

CaseStudiesController.prototype.preloadImgHrefs = function(href) {
	if (this.caches[href]) return;
	const cacheEntry = jcache.getCache(href);
	this.caches[href] = {
		cacheEntry,
		href,
		status: "requested"
	};
}

CaseStudiesController.prototype.navDetails = function() {

	const state				= nav.getState();
	const level 	= state.nextParts[2] == "case-study" ? 2 : 1;
	const caseStudy 		= state.nextParts[level];
	const previousCaseStudy = state.previousParts[level];

	const type				= caseStudy ? "caseStudy" : "main";
	const previousType		= previousCaseStudy ? "caseStudy" : "main";

	const levelChange		= type !== previousType;

	const sectionChange		= state.nextParts[level-1] !== state.previousParts[level-1];

	return {caseStudy,previousCaseStudy,type,previousType,levelChange,state, sectionChange}
}

CaseStudiesController.prototype.fixDiv = function(div) {
	div.style.top = `${-window.scrollY}px`;
	div.style.position = "fixed";
	div.classList.add("backgrounded")
}

CaseStudiesController.prototype.unfixDiv = function(div) {
	div.style.position = "";
	div.style.top = "";
	div.classList.remove("backgrounded")
}

CaseStudiesController.prototype.loadHtml = function($wrapper, images = true){
	const state = nav.getState();
	const cache = jcache.getCache(state.nextUrl);
	const $page = cache.$get(".js-body",images);
	$wrapper.html($page); // using jquery as it's what we do in baseController
	nav.addToLinks($wrapper.find("a"));

	Aviator.get("baseController").processImages($(".page-wrapper"),false,	false);
}
